import { browserName, CustomView, mobileVendor, osName } from "react-device-detect";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@monorepo/components";
import { APPLE_STORE_APP_LINK, GOOGLE_PLAY_APP_LINK, HUAWEY_APP_GALLERY_APP_LINK, LANGUAGE } from "@monorepo/constants";
import { closeMessageForMobile } from "@monorepo/slices/misc";
import theme from "@monorepo/styles/theme";
import { LanguagesEnum } from "@monorepo/types";
import { Backdrop, Box, Divider, Slide, styled, Typography } from "@mui/material";
import logoPL from "assets/img/easyBillLogo.png";
import logoLT from "assets/img/logo.png";

import { mobileOs, mobileVendors } from "constants/constants";
import { useAppDispatch, useAppSelector } from "hooks";

const StyledMessage = styled("div")(() => ({
  position: "fixed",
  width: "100vw",
  bottom: 0,
  zIndex: 100,
  background: theme.palette.background.paper,
  padding: theme.spacing(4, 2),
  display: "flex",
  flexDirection: "column",
  rowGap: theme.spacing(2),
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
}));

const StoreLink = styled("a")(() => ({
  textDecoration: "none",
}));

const MessageForMobileDevices = () => {
  const node = document.getElementById("message-for-mobile-root") || document.createElement("div");
  const { t } = useTranslation();
  const messageForMobileClosed = useAppSelector((state) => state.miscPersistedSlice.messageForMobileClosed);
  const dispatch = useAppDispatch();
  return ReactDOM.createPortal(
    <>
      <Slide unmountOnExit in={!messageForMobileClosed} direction="up">
        <StyledMessage>
          <Typography align="center">{t("common.message_for_mobile")}</Typography>
          <Divider />
          <Box sx={{ display: "flex", flexDirection: "column", rowGap: theme.spacing(2) }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  columnGap: theme.spacing(1),
                }}
              >
                <Box
                  draggable={false}
                  component="img"
                  src={LANGUAGE === LanguagesEnum.PL ? logoPL : logoLT}
                  alt={t("common.perlasgo_logo_alt")}
                  sx={{
                    height: "60px",
                  }}
                />
              </Box>
              <CustomView condition={osName === mobileOs.ANDROID}>
                <CustomView condition={mobileVendor === mobileVendors.HUAWEY}>
                  {/* TODO PGP-217 change link to easyBill for PL language */}
                  <StoreLink href={HUAWEY_APP_GALLERY_APP_LINK} target="_blank" rel="noreferrer">
                    <Button
                      onClick={() => {
                        dispatch(closeMessageForMobile());
                      }}
                    >
                      {t("common.download")}
                    </Button>
                  </StoreLink>
                </CustomView>
                <CustomView condition={mobileVendor !== mobileVendors.HUAWEY}>
                  {/* TODO PGP-217 change link to easyBill for PL language */}
                  <StoreLink href={GOOGLE_PLAY_APP_LINK} target="_blank" rel="noreferrer">
                    <Button
                      onClick={() => {
                        dispatch(closeMessageForMobile());
                      }}
                    >
                      {t("common.download")}
                    </Button>
                  </StoreLink>
                </CustomView>
              </CustomView>
              <CustomView condition={mobileVendor === mobileVendors.APPLE}>
                {/* TODO PGP-217 change link to easyBill for PL language */}
                <StoreLink href={APPLE_STORE_APP_LINK} target="_blank" rel="noreferrer">
                  <Button
                    onClick={() => {
                      dispatch(closeMessageForMobile());
                    }}
                  >
                    {t("common.download")}
                  </Button>
                </StoreLink>
              </CustomView>
            </Box>
            <Button
              onClick={() => {
                dispatch(closeMessageForMobile());
              }}
            >
              {t("common.continue_using")}&nbsp;{browserName}
            </Button>
          </Box>
        </StyledMessage>
      </Slide>
      <Backdrop
        sx={{ zIndex: 2 }}
        open={!messageForMobileClosed}
        onClick={() => {
          dispatch(closeMessageForMobile());
        }}
      />
    </>,
    node
  );
};

export default MessageForMobileDevices;
